import axios from "axios";

export const httpClient = axios.create({
    baseURL: "https://adminxiva.amusoft.uz/api"
})
